import { createAsyncReducer } from '@telstra-connect/standard-actions/reducers';
import {
    IGlobalLocationServiceIDsAction,
    IGlobalLocationServiceIDsSuccessAction,
    IGlobalLocationServiceIDsErrorAction
} from '../../actions/global/location-service-ids';
import { ITicketsState } from '@telstra-connect/tickets/state';
import { initialState } from '../initial-state';

export type GlobalLocationServiceIDsAction
    = IGlobalLocationServiceIDsAction
    | IGlobalLocationServiceIDsSuccessAction
    | IGlobalLocationServiceIDsErrorAction;

const init = (state: ITicketsState, action: GlobalLocationServiceIDsAction) => ({
    ...state,
    globalLocationServiceIDsRequest: {
        ...initialState.globalLocationServiceIDsRequest,
        status: action.status,
    }
});

const success = (state: ITicketsState, action: GlobalLocationServiceIDsAction) => ({
    ...state,
    globalLocationServiceIDsRequest: {
        ...initialState.globalLocationServiceIDsRequest,
        status: action.status,
        data: (action as IGlobalLocationServiceIDsSuccessAction).data
    }
});

const failure = (state: ITicketsState, action: GlobalLocationServiceIDsAction) => ({
    ...state,
    globalLocationServiceIDsRequest: {
        ...initialState.globalLocationServiceIDsRequest,
        status: action.status,
        error: (action as IGlobalLocationServiceIDsErrorAction).error
    }
});

export const globalLocationServiceIDsReducer = createAsyncReducer(initialState, init, success, failure);
